import { render, staticRenderFns } from "./appointWx.vue?vue&type=template&id=0dacc12e&scoped=true&"
import script from "./appointWx.vue?vue&type=script&lang=js&"
export * from "./appointWx.vue?vue&type=script&lang=js&"
import style0 from "./appointWx.vue?vue&type=style&index=0&id=0dacc12e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dacc12e",
  null
  
)

export default component.exports